module.exports = __webpack_public_path__ + "static/img/role-cn.ec2f6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/role-cn.png
// module id = TEP0
// module chunks = 1